<template>
  <div id="app">
    <router-view />
    <GatewaySessionPromptModal />
  </div>
</template>

<script>
import GatewaySessionPromptModal from '@/components/GatewaySessionPromptModal.vue'

export default {
  name: 'App',
  components: { GatewaySessionPromptModal },
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */
</style>
